import { Controller } from "@hotwired/stimulus";
import axios from "axios";
import bootstrap_alert from "../bootstrap_alert";
import { toggleSections } from "../section_appearance";
import * as Sentry from "@sentry/browser";

export default class ProjectCreation extends Controller {
  initialize() {
    this.locale = this.data.get("locale");
    this.countryCode = this.data.get("countryCode");
    this.auth = this.data.get("auth");
    this.projectData = this.data.get("projectData");
    const data = JSON.parse(this.projectData);
    // to store project creation data
    this.formData = {};
    // set default values/types
    this.formData.project_answers_attributes = {};

    if (this.projectData) {
      this.setDataFromPreviousSteps(data);
      this.getServiceQuestions(data);
    }
  }

  connect() {
    I18n.locale = this.locale;
  }

  setDataFromPreviousSteps(data) {
    this.formData.title = data.title;
    this.formData.status = data.type;
    this.formData.service_ids = data.service_ids;
    this.formData.package_id = data.package_id || null;
    this.formData.voucher_id = data.voucher_id || null;
    this.formData.professional_id = data.professional_id || null;
  }

  async getServiceQuestions(data) {
    try {
      await axios({
        method: "get",
        url: `/${this.countryCode}/${this.locale}/questions`,
        params: {
          "question[service_ids]": data.service_ids,
        },
        headers: {
          Accept: "text/vnd.turbo-stream.html, text/html, application/json",
        },
      }).then((response) => {
        // to render turbo response when use axios we have to call renderStreamMessage
        Turbo.renderStreamMessage(response.data);
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  }

  // ===== Questionnaire =====
  setAnswer(event) {
    event.preventDefault();
    const element = event?.target?.closest("[data-project-creation-index]");
    const index = element?.dataset?.projectCreationIndex;
    const questionElment = document.getElementById(`service-question-${index}`);

    const answer =
      document.getElementById(`input-number-${index}`)?.value ||
      document.getElementById(`input-text-${index}`)?.value;

    this.formData.project_answers_attributes[index] = {
      question: questionElment?.dataset.projectCreationQuestion,
      answer: element?.dataset?.projectCreationAnswer || answer,
      question_en: questionElment?.dataset.projectCreationQuestionEn,
      answer_en: element?.dataset?.projectCreationAnswerEn || answer,
      question_ar: questionElment?.dataset.projectCreationQuestionAr,
      answer_ar: element?.dataset?.projectCreationAnswerAr || answer,
    };

    this.afterSettingTheAnswer(questionElment, parseInt(index));
  }

  afterSettingTheAnswer(questionElment, index) {
    questionElment?.dataset.projectCreationQuestionsCount == index + 1
      ? // this is the last question
        toggleSections(true, "project-description")
      : // show the next question
        toggleSections(true, `service-question-${index + 1}`);

    questionElment?.classList.add("d-none");
    document
      .getElementById(`question-indicator-${index + 1}`)
      ?.classList.add("fill-primary");

    toggleSections(true, "go-to-previus-q");
    toggleSections(false, "go-to-previus-step");
  }

  questionnaireHandleBack() {
    const visibleElement = this.findVisibleQuestion();
    const currentIndex = this.getCurrentIndex(visibleElement);
    if (currentIndex == 1) {
      toggleSections(false, "go-to-previus-q");
      toggleSections(true, "go-to-previus-step");
    }
    if (currentIndex > 0) {
      this.showPreviusQuestion(currentIndex);
      document
        .getElementById(`question-indicator-${currentIndex}`)
        ?.classList.remove("fill-primary");
      if (!visibleElement) toggleSections(false, "project-description");
    }
  }

  findVisibleQuestion() {
    return Array.from(document.getElementsByClassName("service-question")).find(
      (element) => !element.classList.contains("d-none"),
    );
  }

  getCurrentIndex(visibleElement) {
    if (!visibleElement) {
      return document.getElementById("project-description").dataset
        .projectCreationQuestionsCount;
    }
    return parseInt(visibleElement?.attributes["key"].value);
  }

  showPreviusQuestion(index) {
    toggleSections(false, `service-question-${index}`);
    toggleSections(true, `service-question-${index - 1}`);
  }

  // ===== Project Description =====
  setSampleFile(event) {
    const fileInput = event.target;
    const fileName = fileInput.files[0]?.name;
    const label = fileInput.nextElementSibling;
    if (label && label.classList.contains("form-label")) {
      label.textContent = fileName;
    }
    this.formData.sample_file = fileInput.files[0];
  }

  submitProjectDescription(event) {
    event.preventDefault();
    const description = document.getElementById("project_description").value;
    this.formData.description = description;
    $("#projectSubmitionModal").modal("show");
  }

  // ===== Submit all collected data =====
  async submitProjectCreation() {
    try {
      await axios({
        method: "post",
        url: `/${this.countryCode}/${this.locale}/projects`,
        data: { project: this.formData },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRF-Token": this.auth,
          Accept: "text/vnd.turbo-stream.html, text/html, application/json",
        },
      }).then((response) => {
        const redirectedURL = response.request?.responseURL; // check for the redirect URL
        if (response.status == 200 && redirectedURL) {
          Turbo.visit(redirectedURL); // to triggers a Turbo navigation
        } else {
          bootstrap_alert.error(
            I18n.translate("stimulus.project_creation.failure_message"),
          );
          Sentry.captureMessage("Faild to create a project.");
        }
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  }
}
